import { Navigate, useLocation } from 'react-router-dom';
import { CircularProgress, Box } from '@mui/material';
import { usePermissions } from '../hooks/usePermissions';

/**
 * PMRoute - Protected route component that checks authentication.
 * Uses AuthContext for auth state (no direct fetch).
 *
 * While loading: Shows centered spinner
 * If authenticated: Renders children
 * If not authenticated: Redirects to login page
 */
const PMRoute = ({ children }) => {
    const { isAuthenticated, isLoading } = usePermissions();
    const location = useLocation();

    if (isLoading) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
                <CircularProgress />
            </Box>
        );
    }

    if (!isAuthenticated) {
        return <Navigate to="/" state={{ from: location }} />;
    }

    return children;
};

export default PMRoute;
